@if (showLogin) {
  <div class="login-page">
    <h2 class="welcome-title">{{ showTitle ? "welcome to the new dictionary": "Go see Roberto... and bring ten euro" }}</h2>
    @if (showTitle){
      <ak-login-form (submitted)="onLoginSubmit($event)" (forgotPassword)="showTitle = false"/>
    }
  </div>
} @else {
  <mat-sidenav-container>
    <mat-sidenav mode="over" [opened]="selectors.isMenuOpen()" (closedStart)="onMenuClosing()">
      <app-sidebar />
    </mat-sidenav>
    <mat-sidenav-content>
      <mat-toolbar class="app-header">
        <mat-toolbar-row>
          <div class="toolbar-actions">
            <button
              mat-icon-button
              data-open-menu-button
              class="header-button"
              [disabled]="selectors.isDICMember() === false"
              (click)="onMenuOpenClick()"
            >
              <mat-icon svgIcon="ak-menu"></mat-icon>
            </button>
            <h1 class="app-name" [routerLink]="['/translation-editor']">New Dictionary</h1>
          </div>
          <span class="spacer"></span>
          <mat-menu #userMenu="matMenu">
<!--            @if (selectors.isDICMember() === true) {-->
              <button mat-menu-item (click)="onEditorSettingsClick()">
                <mat-icon svgIcon="ak-gear"></mat-icon>
                editor settings
              </button>
<!--            }-->
            <button mat-menu-item (click)="onLogoutClick()">
              <mat-icon svgIcon="ak-exit-app"></mat-icon>
              logout
            </button>
          </mat-menu>
          <!--        <ak-user-picture [menuTriggerFor]="userMenu" [src]="selectors.user()?.picture!" />-->
          <button  matButton [matMenuTriggerFor]="userMenu"> User </button>
        </mat-toolbar-row>
      </mat-toolbar>
      <section class="content-container">
        <router-outlet></router-outlet>
      </section>
    </mat-sidenav-content>
  </mat-sidenav-container>
  @if (selectors.isAppLoading()) {
    <div class="app-loading-indicator">
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>
  }
}

<div class="version">v {{environment.version}}</div>


